import React from "react";
import { DocumentacionReclamo } from "../ModalIngresoReclamo/DocumentacionReclamo";

export const DocumentacionReclamosMenu = ({ solicitud, disabled }) => {
  return <DocumentacionReclamo solicitud={solicitud} disabled={disabled} />;
};
